import { createUseQuery } from 'api/common/createUseQuery'

import { AwardsFile } from '../../types/AwardsFile'
import { fetchDetails } from '../fetchers/fetchDetails'

export const useFetchDetails = (slug: string, options = {}) => {
  const useQuery = createUseQuery({
    queryKey: ['DETAILS', slug],
    fetcher: () => fetchDetails(slug),
    selector: res => res?.data ?? ({} as AwardsFile),
  })

  const query = useQuery(options)

  return {
    data: query.data,
    error: query.error,
    isLoading: query.isLoading,
  }
}
